import {
  AlertTriangle,
  CheckCircle2,
  ClipboardCheck,
  Clock,
} from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface Props {
  totalSessions: number;
  completedSessions: number;
  draftSessions: number;
  totalDiscrepancies: number;
}

export function StockOpnameSummaryCards({
  totalSessions,
  completedSessions,
  draftSessions,
  totalDiscrepancies,
}: Props) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
      <Card className="shadow-xs">
        <CardHeader className="flex flex-row items-center justify-between p-3 sm:p-6 pb-1 sm:pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium text-muted-foreground line-clamp-1">
            Total Sesi Opname
          </CardTitle>
          <ClipboardCheck className="h-3.5 w-3.5 sm:h-4 sm:w-4 shrink-0 text-muted-foreground" />
        </CardHeader>
        <CardContent className="p-3 sm:p-6 pt-0 sm:pt-0">
          <div className="text-lg sm:text-2xl font-bold">{totalSessions}</div>
          <p className="mt-0.5 sm:mt-1 text-[10px] sm:text-xs text-muted-foreground line-clamp-1">
            Riwayat penghitungan stok toko
          </p>
        </CardContent>
      </Card>

      <Card className="shadow-xs">
        <CardHeader className="flex flex-row items-center justify-between p-3 sm:p-6 pb-1 sm:pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium text-muted-foreground line-clamp-1">
            Selesai Disesuaikan
          </CardTitle>
          <CheckCircle2 className="h-3.5 w-3.5 sm:h-4 sm:w-4 shrink-0 text-emerald-500" />
        </CardHeader>
        <CardContent className="p-3 sm:p-6 pt-0 sm:pt-0">
          <div className="text-lg sm:text-2xl font-bold text-emerald-600 dark:text-emerald-400">
            {completedSessions}
          </div>
          <p className="mt-0.5 sm:mt-1 text-[10px] sm:text-xs text-muted-foreground line-clamp-1">
            Stok sistem telah diperbarui
          </p>
        </CardContent>
      </Card>

      <Card className="shadow-xs">
        <CardHeader className="flex flex-row items-center justify-between p-3 sm:p-6 pb-1 sm:pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium text-muted-foreground line-clamp-1">
            Draft / Sedang Berjalan
          </CardTitle>
          <Clock className="h-3.5 w-3.5 sm:h-4 sm:w-4 shrink-0 text-amber-500" />
        </CardHeader>
        <CardContent className="p-3 sm:p-6 pt-0 sm:pt-0">
          <div className="text-lg sm:text-2xl font-bold text-amber-600 dark:text-amber-400">
            {draftSessions}
          </div>
          <p className="mt-0.5 sm:mt-1 text-[10px] sm:text-xs text-muted-foreground line-clamp-1">
            Menunggu penyelesaian fisik
          </p>
        </CardContent>
      </Card>

      <Card className="shadow-xs">
        <CardHeader className="flex flex-row items-center justify-between p-3 sm:p-6 pb-1 sm:pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium text-muted-foreground line-clamp-1">
            Akumulasi Item Selisih
          </CardTitle>
          <AlertTriangle className="h-3.5 w-3.5 sm:h-4 sm:w-4 shrink-0 text-destructive" />
        </CardHeader>
        <CardContent className="p-3 sm:p-6 pt-0 sm:pt-0">
          <div className="text-lg sm:text-2xl font-bold text-destructive">
            {totalDiscrepancies}
          </div>
          <p className="mt-0.5 sm:mt-1 text-[10px] sm:text-xs text-muted-foreground line-clamp-1">
            Total temuan selisih fisik vs sistem
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
